import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';
import { Typography } from 'app/components/ui';
import { useUpdateTag } from 'entities/tag';
import { isEscapedConceptType } from 'app/utils/tag-utils/getConceptNarrowType';

interface EscapeSwitchProps {
  tagId: string;
  documentSuperId: number;
  currentEscapeValue: boolean | null | undefined;
  conceptType: { typeQname?: string | null; baseXbrliType?: string | null } | null | undefined;
  disabled?: boolean;
}

export const EscapeSwitch = ({ tagId, documentSuperId, currentEscapeValue, conceptType, disabled = false }: EscapeSwitchProps) => {
  const { t } = useTranslation('tag');

  const { mutate: updateTag } = useUpdateTag();

  const conceptDefault = isEscapedConceptType(conceptType);
  const checked = currentEscapeValue ?? conceptDefault;
  const diverges = checked !== conceptDefault;

  const handleUpdate = (escape: boolean) => {
    updateTag({ id: tagId, documentSuperId, escape });
  };

  return (
    <>
      <div className="property-row">
        <Typography fontWeight="semibold" className="property-label">
          {t('concept.escape.label')}
        </Typography>
        <Form.Check
          type="switch"
          id={`escape-switch-${tagId}`}
          checked={checked}
          onChange={(e) => handleUpdate(e.target.checked)}
          disabled={disabled}
          style={disabled ? { cursor: 'not-allowed' } : undefined}
        />
      </div>
      {diverges && (
        <Typography variant="body-1" fontWeight="light" color="#717077" className="escape-divergence-hint">
          {t('concept.escape.diverges')}
        </Typography>
      )}
    </>
  );
};
